import { render, staticRenderFns } from "./联系我们.vue?vue&type=template&id=148d4276&scoped=true&"
import script from "./联系我们.vue?vue&type=script&lang=js&"
export * from "./联系我们.vue?vue&type=script&lang=js&"
import style0 from "./联系我们.vue?vue&type=style&index=0&id=148d4276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d4276",
  null
  
)

export default component.exports